import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router'
import { ustawRaportZablokowania } from './dane/db.js'
import { useSesja } from './dane/sesja.js'
import { Kalendarz } from './ekrany/Kalendarz.js'
import { Koszty } from './ekrany/Koszty.js'
import { Logowanie } from './ekrany/Logowanie.js'
import { Pulpit } from './ekrany/Pulpit.js'
import { Wiecej } from './ekrany/Wiecej.js'
import { Aktualizacja } from './ui/Aktualizacja.js'
import { DodajPozycje } from './ui/DodajPozycje.js'
import { Instalacja } from './ui/Instalacja.js'
import { Nawigacja } from './ui/Nawigacja.js'
import { PasekPolaczenia } from './ui/PasekPolaczenia.js'
import { useToast } from './ui/Toast.js'
import './ui/powloka.css'

function Wczytywanie() {
  return (
    <div className="powloka-startowa" role="status" aria-live="polite">
      <span className="tylko-dla-czytnika">Wczytywanie aplikacji</span>
      <span className="powloka-startowa__kropka" />
    </div>
  )
}

export function App() {
  const toast = useToast()

  // Baza czeka na zamknięcie innej karty. Bez tej informacji zapisy po prostu
  // przestają się kończyć i wygląda to na zawieszoną aplikację.
  useEffect(() => {
    ustawRaportZablokowania(() => {
      toast.pokazBlad('Aplikacja jest otwarta w innej karcie — zamknij ją i odśwież tę stronę.')
    })
    return () => ustawRaportZablokowania(null)
  }, [toast])

  return (
    <>
      {/* Nad wszystkim, także nad ekranem logowania — nowa wersja może
          czekać niezależnie od tego, czy ktoś jest zalogowany. */}
      <Aktualizacja />
      <Instalacja />
      <Zawartosc />
    </>
  )
}

function Zawartosc() {
  const { stan } = useSesja()
  const { pathname } = useLocation()

  if (stan === 'sprawdzanie') return <Wczytywanie />
  if (stan === 'niezalogowany') return <Logowanie />

  return (
    <div className="powloka">
      <Nawigacja />
      <main className="powloka__tresc">
        <PasekPolaczenia />
        {/* Klucz na ścieżce sprawia, że zawartość odtwarza wejście przy każdej
            zmianie ekranu — przejście pokazuje, że to inne miejsce, nie odświeżenie. */}
        <div className="przejscie-ekranu" key={pathname}>
          <Routes>
          <Route path="/" element={<Pulpit />} />
          <Route path="/kalendarz" element={<Kalendarz />} />
          <Route path="/koszty" element={<Koszty />} />
          <Route path="/wiecej" element={<Wiecej />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
      <DodajPozycje />
    </div>
  )
}
